import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import Footer from "../components/Footer";
import main_logo from '../assets/images/UPG_site_logo.png';
import { GetPages, GetFaq } from '../API/admin'
import { Profile, FilterDynamicText } from '../API/admin'
import { PhotoAPI } from '../API/player';
import Swal from "sweetalert2";
import { useSnackbar } from 'notistack'
import Loader from '../views/admin/Common/Loader'

function Faq_user() {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [dynamicHeading, setDynamicHeading] = useState({});

    const [loginUser, setLoginUser] = useState(null)
    const [allFaq, setallFaq] = useState([]);
    let [loaderStatus, setloaderStatus] = useState(true)


    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
    useEffect(() => {

        let callAPI = async () => {

            let res = await Profile();
            console.log(res)
            if (res && res.statusCode == 403) {
                setLoginUser(null)
                setloaderStatus(false)

            } else {
                setLoginUser(res.data)
                setloaderStatus(false)

            }
        }

        let getfaqAPI = async () => {
            let res = await GetFaq()
            console.log(res.data)
            if (res && res.status) {
                setallFaq(res.data);
            } else {
                setallFaq([]);
            }
        }
        callAPI()
        getfaqAPI()
        // FetchAllPointsAPi()
    }, [])


    //  Photo/Video Request hit 
    useEffect(() => {

        let callAPIDynamictext = async () => {
            let formData = {
                "data": null
            }
            let res = await FilterDynamicText(formData);
            if (res.data.status) {
                console.log(res.data.data)
                setDynamicHeading(res.data.data)
            }
        }
        callAPIDynamictext();
    }, [])

    let PhotoReq = async () => {
        console.log("Hello")
        Swal.fire({
            title: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.title
                : "Request photo/video?",
            text: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.value : "Request photo/video?",
            // icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send Request",
            cancelButtonText: "Close"

        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await PhotoAPI();
                if (res.data.status) {
                    if (res.data.NoMatch) {
                        enqueueSnackbar('You have not played any matches yet', {
                            variant: 'error', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    } else {

                        enqueueSnackbar('Request was sent successfully', {
                            variant: 'success', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    }
                } else {
                    enqueueSnackbar('Unable to send request at the moment', {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    })
                }

            }
        });

    }

    //    My profile navigation
    let Myprofilenavigate;
    if (loginUser) {
        switch (loginUser.role) {
            case "participant":
                Myprofilenavigate = "/participant/profile";
                break;
            case "admin":
                Myprofilenavigate = "/admin/profile";
                break;
            case "scorer":
                Myprofilenavigate = "/scorer/profile";
                break;
            default:
                Myprofilenavigate = "/";
                break;
        }
    } else {
        Myprofilenavigate = "/"; // Redirect to login if user is not logged in
    }


    return (
        <>
            <div className="main_div_heigtport">
                <header>
                    <nav className="navbar navbar-expand-lg navbar-light pt-3 pb-2 px-5 head_nav_landingpage">
                        <a className="navbar-brand" href="/">
                            <img src={main_logo} alt="Logo" />
                        </a>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            style={{ background: '#B2022F' }}
                        >
                            {/* <span className="navbar-toggler-icon" /> */}
                            <i class="bi bi-list" style={{ color: "#fff", fontSize: "25px" }}></i>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav ms-auto nav-list">
                                {
                                    loginUser != null ? (
                                        <>
                                           <li className="nav-item">
                                           <a className="nav_page_btn"  href="/">
                                                    Home
                                                </a>
                                            </li>
                                            <li className='nav-item'
                                                style={{ display: (loginUser != null) ? "block" : "none" }} >
                                                <NavLink className='nav_page_btn mobile_displa_dashboard' to='/dashboard' activeClassName='active'>
                                                    Dashboard
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                <NavLink className='nav_page_btn' to='/Results' activeClassName='active'>
                                                    Results
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                <NavLink className='nav_page_btn' to='/photo-gallery' activeClassName='active'>
                                                    Gallery
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                <NavLink className='nav_page_btn' to='/contact' activeClassName='active'>
                                                    Get in Touch
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown">
                                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <img
                                                        src={loginUser.profile_image !== undefined ?
                                                            IMAGE_URL + "user/" + loginUser.profile_image : IMAGE_URL + "blank_user.png"}
                                                        alt="Profile"
                                                        className="rounded-circle"
                                                        style={{
                                                            width: "60px",
                                                            height: "60px",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu-end new_header_dropdown" aria-labelledby="navbarDropdown">
                                                    <li className='mobile_displa_popup_dashboard'>
                                                        <NavLink className="dropdown-item" to="/dashboard">Dashboard</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink className="dropdown-item" to={Myprofilenavigate}>My Profile</NavLink>
                                                    </li>
                                                    <li style={{ display: (loginUser.role === "participant") ? "block" : "none" }}
                                                        onClick={() => PhotoReq()}>
                                                        <Link className="dropdown-item"> Request Photo/Video</Link>
                                                    </li>
                                                    <li>
                                                        <Link className="dropdown-item" to="/logout">Logout</Link>
                                                    </li>
                                                </ul>
                                            </li>
                                        </>
                                    ) : (
                                        <>
                                           <li className="nav-item">
                                           <a className="nav_page_btn"  href="/">
                                                    Home
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {/* Changed to NavLink */}
                                                <NavLink className='nav_page_btn' to='/Results' activeClassName='active'>
                                                    Results
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                {/* Changed to NavLink */}
                                                <NavLink className='nav_page_btn' to='/photo-gallery' activeClassName='active'>
                                                    Gallery
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                {/* Changed to NavLink */}
                                                <NavLink className='nav_page_btn' to='/contact' activeClassName='active'>
                                                    Get in Touch
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                {/* Changed to NavLink */}
                                                <NavLink className="signup_btn" to="/register" activeClassName='active'>
                                                    Register Now
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                {/* Changed to NavLink */}
                                                <NavLink className="login_btn" to="/login" activeClassName='active'>
                                                    Login
                                                </NavLink>
                                            </li>
                                        </>
                                    )
                                }
                            </ul>
                        </div>
                    </nav>
                </header>
                <section className='headre_bg_div'></section>
                <div className='container-fluid pt-4 ' style={{ background: "#000" }}>
                    <div className='container-lg text-white'>
                        <h3 className='all_new_pages_heading'>
                            FREQUENTLY ASKED QUESTIONS
                        </h3>
                    </div>
                </div>
                <section className="container-fluid faq_block pt-1 pb-3 flex-grow-1" id="faqs">
                    <div className="container">
                        {/* <h3 className="fw-bold text-white pb-4">
                            Frequently Asked Questions
                        </h3> */}
                        <div id="accordionPanelsStayOpenExample1" class="accordion m-auto ">
                            {
                                allFaq.length > 0 ? (
                                    allFaq.map((faq, index) => (
                                        <div class="accordion-item rounded-5">
                                            <div class="accordion-header">
                                                <button type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapse${index}`}
                                                    aria-expanded="true" aria-controls={`panelsStayOpen-collapse${index}`} class="accordion-button collapsed">
                                                    {faq.question}
                                                </button>
                                            </div>
                                            <div id={`panelsStayOpen-collapse${index}`} data-bs-parent="#accordionPanelsStayOpenExample1"
                                                class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    {faq.answer}
                                                </div>
                                            </div>
                                        </div>

                                    )

                                    )

                                ) :
                                    <>
                                        <div className='d-flex align-items center'>
                                            <div className='nodata_row bg-dark'>
                                                No frequently asked questions found
                                            </div>
                                        </div>
                                    </>
                            }

                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    )
}

export default Faq_user
